import axiosInstance from "../axiosInterceptor";

export async function getAllCountries() {
  const response = await axiosInstance.get(`/admin/country/getAllCountry`);
  const data = response?.data;
  return data;
}
